import { Select } from "antd";
import classNames from "classnames";
import { get, isEmpty, isObject } from "lodash";
import Label from "shared/components/Label";
import { useQuery } from "shared/hooks/useApi";

const Async = ({
  label: selectLabel,
  node,
  errors,
  icon,
  labels,
  onChange = () => {},
  onSearch = () => {},
  touched,
  required,
  optional,
  filter,
  optionFilterProp = "label",
  ...rest
}) => {
  const {
    query,
    variables,
    accessors: { root, label = "name", value = "id" },
    fallback = [],
  } = node;
  const resolveAccessorKey = (item, key, separator) => {
    const [principal, alt] = key.split(separator);
    const principalValue = get(item, principal);
    if (principalValue !== undefined && principalValue !== null) {
      return principalValue;
    }
    if (alt) {
      const altValue = get(item, alt);
      if (altValue !== undefined && altValue !== null) {
        return altValue;
      }
    }
    return "";
  };

  const getLabel = (item) => {
    if (!isEmpty(labels)) return labels[get(item, label)];
    if (isObject(label)) {
      const separator = get(label, "separator", "-");
      return get(label, "keys", [])
        .map((key) => resolveAccessorKey(item, key, separator))
        .join(separator);
    }
    return get(item, label);
  };
  const { data, loading } = useQuery(query, { variables });

  const sourceItems = isEmpty(get(data, root, []))
    ? fallback
    : get(data, root, []);
  const items = sourceItems.map((item) => ({
    label: getLabel(item),
    value: get(item, value).toString(),
  }));

  return (
    <div
      className={classNames("select__wrapper", { __error: touched && errors })}
    >
      <Label
        label={selectLabel}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className={`select__wrapper--field`}>
        <Select
          size="large"
          className={classNames({ "disable--input": rest.disabled })}
          loading={loading}
          onChange={(selectedValue) => {
            return onChange(
              selectedValue,
              sourceItems.find(
                (item) => String(get(item, value)) === String(selectedValue),
              ),
            );
          }}
          showSearch
          optionFilterProp={optionFilterProp}
          onSearch={onSearch}
          options={filter ? items.filter(filter) : items}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

export default Async;
